export enum ListStyle {
  row = "row",
  grid = "grid"
}
